import { api } from ".";

const basePath = "/department";

export const createDepartment = async ({ name, description, workHours }: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      description,
      workHours
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateDepartmentById = async ({ id, updates, workHours }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
      workHours,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getDepartmentsList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteDepartment = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const getDepartmentSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};
